module.exports = __webpack_public_path__ + "static/media/cube-vec.82f634b0.png";